export default "__VITE_ASSET__DOyHqH_Y__"